import useMember from "../../../hooks/useMember";
import { memberLogout } from "../../../api/apiServices"
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const MemberLogout = () => {
    const { setMem } = useMember();
    const navigate = useNavigate();
    


    useEffect(() => {
        setMem({});
        try {
            memberLogout();
            navigate('/');
        } catch (err) {
            console.error(err);
        }

    },[]);


}

export default MemberLogout;
